/* eslint-disable no-use-before-define */
import {
  put,
  all,
  take,
  takeEvery,
  fork,
  select,
  call
} from "redux-saga/effects";
import * as R from "ramda";
import Helpers from "utils/Global/Helpers";
import { debounce, makeFuture } from "utils/General/sagas";
import {
  TABS,
  FIELD_IDS,
  SESSION_FORM_ID,
  DATE_FORMAT,
  LOCATION_TYPE_IDS,
  CONTENT_MODAL_ID,
  SESSION_MODAL_TABS_INSTANCE_ID,
  FROM_SESSION_PAGE
} from "./constants";
import moment from "moment-timezone";
import { apiCall } from "App/Data/sagas";
import { CONTENT_VIDEO } from "./constants";
import { getCredentials } from "redux/modules/user/selectors";
import {
  eventDetails as getEventDetails,
  eventId as getEventId
} from "redux/modules/event/selectors";
import { getEditedField } from "./selectors";
import { showSnackbar } from "redux/modules/snackbar/actions";
import { actions, getters } from "./model";
import { registerError } from "redux/modules/errors/actions";
import { actions as MediaContentActions } from "ui-kit/MediaContentModal/model";
import { actions as FormActions } from "ui-kit/Form/model";
import { actions as TabsActions } from "ui-kit/Tabs";
import { actions as SessionContentActions } from "../SessionContent/model";
import {
  setOtherZone,
  setLocalZone,
  openInNewWindow,
  isEmptyOrNil
} from "utils/General";
import { SUBSESSION_ACTIONS } from "./constants";
import Api from "./api";
// import { actions as submissionsActions } from "EventLight/Sessions/Submissions";
// import { actions as dashboardActions } from "EventLight/Dashboard/model";
import numeral from "numeral";
import { showModal } from "redux/modules/modal/actions";
import ModalWrapper from "components/Global/Modal/Wrappers/Black";
import React from "react";
import BulkEditSpeakersModal from "../BulkEditSpeakersModal/View";

const StyledModalWrapper = ({ children }) => (
  <ModalWrapper style={{ zIndex: 12346 }}>{children}</ModalWrapper>
);

const showBulkEditSpeakersModal = function*() {
  const handleDelete = makeFuture();
  const speakersList = yield select(getters.speakersList);
  const data = yield select(getters.data);
  const selectedSpeakers = R.propOr([], "speakers", data);
  yield put(
    showModal({
      content: (
        <BulkEditSpeakersModal
          speakersList={speakersList}
          selectedSpeakers={selectedSpeakers}
          onSave={speakers => handleDelete.done(speakers)}
          onCancel={() => handleDelete.done(false)}
        />
      ),
      wrapper: StyledModalWrapper
    })
  );
  return yield call(handleDelete.onRealized);
};

const onShowBulkEditSpeakersModal = function*() {
  const result = yield call(showBulkEditSpeakersModal);
  if (result) {
    const data = yield select(getters.data);
    yield put(
      FormActions.setFieldValue(result, {
        meta: { instanceId: SESSION_FORM_ID, fieldId: FIELD_IDS.SPEAKERS }
      })
    );
    yield put(actions.setData({ ...data, speakers: result }));
  }
};

const handleChangeResultPerPage = function*({ payload: { pageSize } }) {
  const filter = yield select(getters.filter);
  const pagination = yield select(getters.pagination);
  yield put(actions.setPagination({ ...pagination, page: 0, pageSize }));
  yield call(searchSessions, {
    payload: {
      filter
    }
  });
};

const handleChangePages = function*({ payload: { page } }) {
  const filter = yield select(getters.filter);
  const pagination = yield select(getters.pagination);
  yield put(actions.setPagination({ ...pagination, page }));
  yield call(searchSessions, {
    payload: {
      filter
    }
  });
};

const linkSessionAsSubsession = function*() {
  const credentials = yield select(getCredentials);
  const parentSessionId = yield select(getters.sessionId);
  const sessionsToConvertIds = yield select(getters.sessionsToConvertIds);
  yield put(actions.setLoading(true));
  try {
    yield call(Api.linkSessionAsSubsession, {
      credentials,
      sessionId: parentSessionId,
      subSessionIds: sessionsToConvertIds
    });
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: error?.message ?? "An error occurred. Please try again."
        }
      ])
    );
    yield put(actions.setLoading(false));
    return false;
  }
  yield put(actions.backSelectedSubssesionsButton());
  yield call(init, {
    payload: {
      sessionId: parentSessionId,
      parentSessionId: null,
      returnToScene: TABS.SUBSESSIONS
    }
  });
  yield put(
    showSnackbar({
      message: "Subsessions successfully created"
    })
  );
  yield put(actions.setLoading(false));
  yield put(actions.onSaveDone());
  yield put(actions.setShowSessionModal(false));

  return true;
};

const getParams = function*() {
  const credentials = yield select(getCredentials);
  const eventDetails = yield select(getEventDetails);

  return {
    credentials,
    eventDetails
  };
};

const init = function*({
  payload: {
    parentSessionId = null,
    sessionId = null,
    status = null,
    startsAt = null,
    endsAt = null,
    roomId = null,
    iniScene = null,
    returnToScene = null,
    convertSessionstoSubsessions = false
  } = {}
}) {
  try {
    yield put(actions.resetDataOnInit());

    yield put(
      FormActions.clearValues(null, {
        meta: {
          instanceId: SESSION_FORM_ID
        }
      })
    );

    const { credentials } = yield call(getParams);

    // const activeTab = yield select(TabsGetters.selectedTab, {
    //   instanceId: SESSION_MODAL_TABS_INSTANCE_ID
    // });

    let sessionData = null;
    let parentSessionData = null;

    if (sessionId) {
      const { payload } = yield call(Api.getSession, {
        credentials,
        sessionId
      });

      const { payload: translatedValues } = yield call(apiCall, {
        method: "get",
        url: `/sessions/session/${sessionId}/translated-values`
      });

      yield put(actions.setTranslatedValues(translatedValues));

      sessionData = payload;
    }

    const parentSessionIdToUse =
      !parentSessionId && sessionData
        ? sessionData?.parent_session_id
        : parentSessionId;

    if (parentSessionIdToUse) {
      const { payload } = yield call(Api.getSession, {
        credentials,
        sessionId: parentSessionIdToUse
      });

      parentSessionData = payload;
    }

    if (!convertSessionstoSubsessions) {
      yield put(
        TabsActions.setSelectedTab(iniScene || TABS.BASIC_DETAILS, {
          meta: {
            instanceId: SESSION_MODAL_TABS_INSTANCE_ID
          }
        })
      );
    }

    yield put(
      actions.setInitialData({
        isSubsession: Boolean(parentSessionIdToUse),
        iniScene,
        returnToScene,
        editing: Boolean(sessionId),
        sessionId,
        sessionData,
        parentSessionId: parentSessionIdToUse,
        parentSessionData,
        status,
        startsAt,
        endsAt,
        roomId,
        convertSessionstoSubsessions
      })
    );
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: "An error occurred while loading session settings"
        }
      ])
    );
  } finally {
    yield put(actions.setLoading(false));
  }
};

const saveAsDraft = function*() {};

const getFilePicker = () =>
  new Promise(resolve => {
    const options = {
      multiple: false,
      accept: [
        "image/bmp",
        "image/gif",
        "image/jpeg",
        "image/svg+xml",
        "image/png"
      ]
    };

    const path = { path: "session-modal/" };

    Helpers.getFilepicker(options, path, resolve);
  });

const uploadHeaderImg = function*() {
  const files = yield call(getFilePicker);
  const url = files[0].url;

  yield put(actions.updateField({ field: "background_image_url", value: url }));
};

const save = function*({ payload }) {
  try {
    yield put(actions.setLoading(true));
    const editing = yield select(getters.editing);
    const sessionId = yield select(getters.sessionId);
    const parentSessionId = yield select(getters.parentSessionId);
    const returnToScene = yield select(getters.returnToScene);

    const { credentials, eventDetails } = yield call(getParams);
    const data = yield select(getters.data);
    const translatedValues = yield select(getters.translatedValues);

    if (payload) {
      data.title = payload.title;
      data.starts_at = payload.startsAt;
      data.ends_at = payload.endsAt;
      data.status = {
        value: payload.status
      };
    }

    const toSave = {
      sessionId,
      parentSessionId,
      eventId: eventDetails.id,
      translatedValues: translatedValues.filter(
        v => v.field_source === "standard"
      ),
      //
      title: data.title,
      startsAt: data.starts_at,
      endsAt: data.ends_at,
      description: data.description,
      isOnlineSession: data.is_online_session,
      backgroundImageUrl: data.background_image_url,
      conferenceUrl: data.conference_url,
      conferenceThumbnailUrl: data.conference_thumbnail_url,
      conferenceTitle: data.conference_title,
      transcriptUrl: data.transcript_url,
      replayUrl: data.replay_url,
      //
      ceuCredits: data.ceu_credits,
      status: data.status
        ? R.pathOr(R.propOr(null, "value")(data.status), [0, "value"])(
            data.status
          )
        : null,
      location: data.location,
      locationRoomId:
        data.location === LOCATION_TYPE_IDS.ROOM &&
        !isEmptyOrNil(data.location_room)
          ? R.path(["value"])(data.location_room)
          : null,
      locationExternalUrl:
        data.location === LOCATION_TYPE_IDS.VIRTUAL &&
        (R.path(["value"], data.session_location_type) ===
          LOCATION_TYPE_IDS.EXTERNAL ||
          data.session_location_type === LOCATION_TYPE_IDS.EXTERNAL)
          ? data.location_external_url
          : null,
      sessionLocationType:
        data.location === LOCATION_TYPE_IDS.VIRTUAL &&
        !isEmptyOrNil(data.session_location_type)
          ? R.path(["value"], data.session_location_type)
          : null,

      tags:
        data.tags && data.tags.length ? R.map(R.prop("value"))(data.tags) : [],
      languageId: data.language
        ? R.pathOr(R.propOr(null, "value")(data.language), [0, "value"])(
            data.language
          )
        : null,
      levelId: data.level
        ? R.pathOr(R.propOr(null, "value")(data.level), [0, "value"])(
            data.level
          )
        : null,
      formatId: data.format
        ? R.pathOr(R.propOr(null, "value")(data.format), [0, "value"])(
            data.format
          )
        : null,
      speakers:
        data.speakers && data.speakers.length
          ? R.map(s => {
              return {
                id: R.prop("value", s),
                isSpeakerPublic: R.prop("isSpeakerPublic", s)
              };
            })(data.speakers)
          : [],
      chairpersons:
        data.chairpersons && data.chairpersons.length
          ? R.map(R.prop("value"))(data.chairpersons)
          : [],
      moderators:
        data.moderators && data.moderators.length
          ? R.map(R.prop("value"))(data.moderators)
          : [],
      sponsors:
        data.sponsors && data.sponsors.length
          ? R.map(R.prop("value"))(data.sponsors)
          : [],
      exhibitors:
        data.exhibitors && data.exhibitors.length
          ? R.map(R.prop("value"))(data.exhibitors)
          : [],
      trackId: data.track
        ? R.pathOr(R.propOr(null, "value")(data.track), [0, "value"])(
            data.track
          )
        : null,
      relatedContent:
        data.related_content && data.related_content.length
          ? R.map(R.prop("id"))(data.related_content)
          : [],
      submittedByContactId:
        data.session_submitter && data.session_submitter.value
          ? data.session_submitter.value
          : data.session_submitter && data.session_submitter.length
          ? R.pathOr(R.propOr(null, "value")(data.session_submitter), [
              0,
              "value"
            ])(data.session_submitter)
          : null
    };

    if (editing) {
      yield call(Api.updateSession, {
        credentials,
        data: toSave
      });
    } else {
      yield call(Api.addSession, {
        credentials,
        data: toSave
      });
    }

    if (returnToScene && returnToScene !== FROM_SESSION_PAGE) {
      yield call(goToParentSession);
      yield put(actions.onSaveDone());
    } else {
      yield put(actions.setShowSessionModal(false));
      yield put(actions.onSaveDone());
    }

    if (parentSessionId) {
      yield put(
        showSnackbar({
          message: parentSessionId
            ? editing
              ? "Subsession successfully updated"
              : "Subsession successfully created"
            : editing
            ? "Session successfully updated"
            : "Session successfully created"
        })
      );
    }
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: error.message
            ? error.message
            : "An error occurred while saving session"
        }
      ])
    );
  } finally {
    yield put(actions.setLoading(false));
    yield put(actions.onSaveDone());
  }
};

const nextPage = function*() {
  const activeTab = yield select(getters.activeTab);

  if (activeTab === TABS.BASIC_DETAILS) {
    yield put(actions.save());
  } else if (activeTab === TABS.ATTENDEE_SETTINGS) {
    yield put(actions.setActiveTab(TABS.CONTENT));
  } else {
    yield put(actions.save());
  }
};

const createSubsession = function*() {
  const parentSessionId = yield select(getters.sessionId);
  const returnToScene = yield select(getters.returnToScene);
  yield put(actions.setLoading(true));

  if (returnToScene !== FROM_SESSION_PAGE) {
    /*
     *  this fires an action that will trigger the initialization of the
     *  session 's page including the subsessions list
     */

    yield put(actions.onSaveDone());
  }

  yield put(
    TabsActions.setSelectedTab(TABS.BASIC_DETAILS, {
      meta: {
        instanceId: SESSION_MODAL_TABS_INSTANCE_ID
      }
    })
  );

  yield call(init, {
    payload: {
      sessionId: null,
      parentSessionId,
      returnToScene: TABS.SUBSESSIONS
    }
  });
};

const goToParentSession = function*() {
  const parentSessionId = yield select(getters.parentSessionId);
  const returnToScene = yield select(getters.returnToScene);

  yield put(actions.setLoading(true));
  yield put(
    TabsActions.setSelectedTab(TABS.BASIC_DETAILS, {
      meta: {
        instanceId: SESSION_MODAL_TABS_INSTANCE_ID
      }
    })
  );
  yield call(init, {
    payload: {
      sessionId: parentSessionId,
      parentSessionId: null,
      iniScene: returnToScene ? returnToScene : null
    }
  });
};

const goToSubsession = function*({ payload: subsessionId }) {
  const parentSessionId = yield select(getters.sessionId);

  yield put(actions.setLoading(true));
  yield put(
    TabsActions.setSelectedTab(TABS.BASIC_DETAILS, {
      meta: {
        instanceId: SESSION_MODAL_TABS_INSTANCE_ID
      }
    })
  );
  yield call(init, {
    payload: {
      sessionId: subsessionId,
      parentSessionId,
      returnToScene: TABS.SUBSESSIONS
    }
  });
};

const onTabChange = function*({ payload: tabId, meta: { instanceId } }) {
  if (instanceId !== SESSION_MODAL_TABS_INSTANCE_ID) {
    return false;
  }

  if (tabId !== TABS.CONTENT) {
    // Anytime we change away from Content tab, we have to force
    // back to loading state here so the Dropzone panel will re-render correctly
    yield put(SessionContentActions.setLoading(true));
  }

  return true;
};

const previousPage = function*() {
  const activeTab = yield select(getters.activeTab);

  if (activeTab === TABS.CONTENT) {
    // yield put(actions.setActiveTab(TABS.ATTENDEE_SETTINGS));
    yield put(actions.setActiveTab(TABS.BASIC_DETAILS));
  } else if (activeTab === TABS.ATTENDEE_SETTINGS) {
    yield put(actions.setActiveTab(TABS.BASIC_DETAILS));
  }
};

const fieldUpdate = function*({ id, fieldId, type }) {
  const eventDetails = yield select(getEventDetails);
  const data = yield select(getters.data);

  const newValue = yield select(getEditedField, {
    instanceId: id,
    fieldId
  });

  // properly format CEU credits on blur
  if (
    type === FormActions.blurField.type &&
    fieldId === FIELD_IDS.CEU_CREDITS
  ) {
    const ceuValue = newValue ? numeral(newValue).format("0.00") : null;

    yield put(
      FormActions.setFieldValue(ceuValue, {
        meta: {
          instanceId: id,
          fieldId: FIELD_IDS.CEU_CREDITS
        }
      })
    );

    return true;
  }

  const processedValue = R.propOr(newValue, fieldId, {
    [FIELD_IDS.CEU_CREDITS]: newValue ? numeral(newValue).format("0.00") : null,
    [FIELD_IDS.LOCATION]: R.path([0], newValue),
    [FIELD_IDS.LOCATION_ROOM]:
      R.length(newValue) === 0
        ? null
        : {
            value: R.path([0, "value"], newValue),
            name: R.path([0, "label"], newValue)
          },
    [FIELD_IDS.VIRTUAL]:
      R.length(newValue) === 0
        ? null
        : {
            value: R.path([0, "value"], newValue),
            name: R.path([0, "label"], newValue)
          },
    [FIELD_IDS.STATUS]: R.path([0], newValue),
    [FIELD_IDS.BACKGROUND_IMAGE_URL]: R.path([0, "url"], newValue),
    [FIELD_IDS.STARTS_AT]: newValue
      ? moment
          .tz(
            moment(
              setOtherZone(newValue, R.prop("timezone", eventDetails))
            ).toDate(),
            DATE_FORMAT,
            R.prop("timezone", eventDetails)
          )
          .utc()
          .format()
      : null,
    [FIELD_IDS.ENDS_AT]: newValue
      ? moment
          .tz(
            moment(
              setOtherZone(newValue, R.prop("timezone", eventDetails))
            ).toDate(),
            DATE_FORMAT,
            R.prop("timezone", eventDetails)
          )
          .utc()
          .format()
      : null
  });

  if (fieldId === FIELD_IDS.STARTS_AT) {
    const start = moment(processedValue);
    let end = moment(data.ends_at);
    if (R.isNil(data.ends_at) || start.isAfter(end)) {
      end = start
        .clone()
        .add(1, "hours")
        .utc()
        .format();
      const endDate = moment(end);
      const val = endDate.isValid() && newValue ? end : null;
      if (val) {
        yield all([
          put(
            actions.updateField({
              field: FIELD_IDS.ENDS_AT,
              value: val
            })
          ),
          put(
            FormActions.setFieldValue(
              setLocalZone(val, R.prop("timezone", eventDetails), true),
              {
                meta: {
                  instanceId: SESSION_FORM_ID,
                  fieldId: FIELD_IDS.ENDS_AT
                }
              }
            )
          )
        ]);
      }
    }
  } else if (fieldId === FIELD_IDS.ENDS_AT) {
    const end = moment(processedValue);
    let start = moment(data.starts_at);
    if (R.isNil(data.starts_at) || end.isBefore(start)) {
      start = end
        .clone()
        .subtract(1, "hours")
        .utc()
        .format();
      const startDate = moment(start);
      const val = startDate.isValid() && newValue ? start : null;
      if (val) {
        yield all([
          put(
            actions.updateField({
              field: FIELD_IDS.STARTS_AT,
              value: val
            })
          ),
          put(
            FormActions.setFieldValue(
              setLocalZone(val, R.prop("timezone", eventDetails), true),
              {
                meta: {
                  instanceId: SESSION_FORM_ID,
                  fieldId: FIELD_IDS.STARTS_AT
                }
              }
            )
          )
        ]);
      }
    }
  }

  const hasChanges = yield select(getters.hasChanges);
  if (!hasChanges) {
    const loadedAt = yield select(getters.loadedAt);
    const changeIsAfterPageLoad = moment().isAfter(
      moment(loadedAt).add(3, "seconds")
    );

    // @TODO: Do 1:1 comparison of data in selector that is called here
    // to replace the mess below
    const oldValueIsNullish = Array.isArray(data[fieldId])
      ? !data[fieldId].length
      : (typeof data[fieldId] !== "object" &&
          (!data[fieldId] || !data[fieldId]?.length)) ||
        !data[fieldId];

    const newValueIsNullish = Array.isArray(processedValue)
      ? !processedValue.length
      : (typeof processedValue !== "object" &&
          (!processedValue || !processedValue?.length)) ||
        !processedValue;

    const isSameValue = processedValue?.value
      ? processedValue?.value === data[fieldId]?.value ||
        processedValue?.value === data[fieldId]?.id
      : processedValue?.id
      ? processedValue?.id === data[fieldId]?.id ||
        processedValue?.id === data[fieldId]?.value
      : data[fieldId] !== processedValue;

    yield all([
      put(actions.updateField({ field: fieldId, value: processedValue })),
      oldValueIsNullish && newValueIsNullish
        ? null
        : changeIsAfterPageLoad && !isSameValue
        ? put(actions.setHasChanges(true))
        : null
    ]);
  } else {
    yield put(actions.updateField({ field: fieldId, value: processedValue }));
  }

  return true;
};

const watchUpdateFields = function*() {
  for (;;) {
    const {
      type,
      meta: { instanceId, fieldId }
    } = yield take([
      FormActions.setFieldValue.type,
      FormActions.blurField.type
    ]);

    if (instanceId === SESSION_FORM_ID) {
      yield call(fieldUpdate, {
        id: instanceId,
        fieldId,
        type
      });
    }
  }
};

const loadAsyncOptions = function*({
  meta: { fieldId, callback },
  payload: search
}) {
  if (FIELD_IDS.TAGS === fieldId) {
    const eventId = yield select(getEventId);
    try {
      const result = yield call(apiCall, {
        method: "get",
        url: `/virtual/event/${eventId}/tags/search`,
        qs: { search }
      });

      const payload = R.prop("payload", result);

      const options = R.compose(
        R.map(el => ({
          value: R.prop("id", el),
          label: R.prop("name", el),
          color: R.prop("color", el)
        }))
      )(payload);

      callback(options);
    } catch (error) {
      yield all([
        put(
          registerError([
            {
              system: error,
              user: "An error occurred fetching options for async dropdown"
            }
          ])
        )
      ]);
    }
  } else if (FIELD_IDS.STATUS === fieldId) {
    const eventId = yield select(getEventId);
    try {
      const result = yield call(apiCall, {
        method: "get",
        url: `/sessions/event/${eventId}/statuses/search`,
        qs: { search }
      });

      const payload = R.prop("payload", result);

      const options = R.compose(
        R.map(el => ({
          value: R.prop("id", el),
          label: R.prop("name", el),
          color: R.prop("color", el)
        }))
      )(payload);

      callback(options);
    } catch (error) {
      yield all([
        put(
          registerError([
            {
              system: error,
              user: "An error occurred fetching options for async dropdown"
            }
          ])
        )
      ]);
    }
  } else if (FIELD_IDS.LEVEL === fieldId) {
    const eventId = yield select(getEventId);
    try {
      const result = yield call(apiCall, {
        method: "get",
        url: `/sessions/event/${eventId}/levels/search`,
        qs: { search }
      });

      const payload = R.prop("payload", result);

      const options = R.compose(
        R.map(el => ({
          value: R.prop("id", el),
          label: R.prop("name", el)
        }))
      )(payload);

      callback(options);
    } catch (error) {
      yield all([
        put(
          registerError([
            {
              system: error,
              user: "An error occurred fetching options for async dropdown"
            }
          ])
        )
      ]);
    }
  } else if (FIELD_IDS.LANGUAGE === fieldId) {
    const eventId = yield select(getEventId);
    try {
      const result = yield call(apiCall, {
        method: "get",
        url: `/sessions/event/${eventId}/languages/search`,
        qs: { search }
      });

      const payload = R.prop("payload", result);

      const options = R.compose(
        R.map(el => ({
          value: R.prop("id", el),
          label: R.prop("name", el)
        }))
      )(payload);

      callback(options);
    } catch (error) {
      yield put(
        registerError([
          {
            system: error,
            user: "An error occurred fetching options for async dropdown"
          }
        ])
      );
    }
  } else if (FIELD_IDS.TRACK === fieldId) {
    const eventId = yield select(getEventId);
    try {
      const result = yield call(apiCall, {
        method: "get",
        url: `/sessions/event/${eventId}/tracks/search`,
        qs: { search }
      });

      const payload = R.prop("payload", result);

      const options = R.compose(
        R.map(el => ({
          value: R.prop("id", el),
          label: R.prop("name", el)
        }))
      )(payload);

      callback(options);
    } catch (error) {
      yield all([
        put(
          registerError([
            {
              system: error,
              user: "An error occurred fetching options for async dropdown"
            }
          ])
        )
      ]);
    }
  } else if (FIELD_IDS.FORMAT === fieldId) {
    const eventId = yield select(getEventId);
    try {
      const result = yield call(apiCall, {
        method: "get",
        url: `/sessions/event/${eventId}/formats/search`,
        qs: { search }
      });

      const payload = R.prop("payload", result);

      const options = R.compose(
        R.map(el => ({
          value: R.prop("id", el),
          label: R.prop("name", el)
        }))
      )(payload);

      callback(options);
    } catch (error) {
      yield all([
        put(
          registerError([
            {
              system: error,
              user: "An error occurred fetching options for async dropdown"
            }
          ])
        )
      ]);
    }
  } else if (
    FIELD_IDS.SPEAKERS === fieldId ||
    FIELD_IDS.MODERATORS === fieldId ||
    FIELD_IDS.CHAIRPERSONS === fieldId
  ) {
    const eventId = yield select(getEventId);
    try {
      const result = yield call(apiCall, {
        method: "get",
        url: `/sessions/event/${eventId}/speakers`,
        qs: { search }
      });

      const payload = R.prop("payload")(result);

      const options = R.compose(
        R.map(el => ({
          value: R.prop("id", el),
          label:
            FIELD_IDS.SPEAKERS === fieldId
              ? [R.propOr("", "name", el), R.prop("id", el)].join(" ")
              : R.propOr("", "name", el),
          ...(FIELD_IDS.SPEAKERS === fieldId
            ? {
                isSpeakerPublic: R.propOr(true, "is_public", el), //default to true
                id: R.prop("id", el),
                name: R.propOr("", "name", el)
              }
            : {})
        }))
      )(payload);

      yield put(actions.setSpeakersList(payload));
      callback(options);
    } catch (error) {
      yield all([
        put(
          registerError([
            {
              system: error,
              user: "An error occurred fetching options for async dropdown"
            }
          ])
        )
      ]);
    }
  } else if (FIELD_IDS.SPONSORS === fieldId) {
    const eventId = yield select(getEventId);
    try {
      const result = yield call(apiCall, {
        method: "get",
        url: `/sessions/event/${eventId}/sponsors`,
        qs: { search }
      });

      const payload = R.prop("payload")(result);

      const options = R.compose(
        R.map(el => ({
          value: R.prop("id", el),
          label: R.prop("name", el)
        }))
      )(payload);

      callback(options);
    } catch (error) {
      yield all([
        put(
          registerError([
            {
              system: error,
              user: "An error occurred fetching options for async dropdown"
            }
          ])
        )
      ]);
    }
  } else if (FIELD_IDS.EXHIBITORS === fieldId) {
    const eventId = yield select(getEventId);
    try {
      const result = yield call(apiCall, {
        method: "get",
        url: `/sessions/event/${eventId}/exhibitors`,
        qs: { search }
      });

      const payload = R.prop("payload")(result);

      const options = R.compose(
        R.map(el => ({
          value: R.prop("id", el),
          label: R.prop("name", el)
        }))
      )(payload);

      callback(options);
    } catch (error) {
      yield all([
        put(
          registerError([
            {
              system: error,
              user: "An error occurred fetching options for async dropdown"
            }
          ])
        )
      ]);
    }
  } else if (FIELD_IDS.LOCATION_ROOM === fieldId) {
    const eventId = yield select(getEventId);
    try {
      const result = yield call(apiCall, {
        method: "get",
        url: `/sessions/event/${eventId}/rooms/search`,
        qs: { search }
      });

      const payload = R.prop("payload", result);

      const rooms = R.compose(
        R.map(room => ({
          value: R.prop("id", room),
          label: `${R.prop("name", room)} (capacity ${
            R.isNil(R.prop("capacity", room)) ? "-" : R.prop("capacity", room)
          })`
        }))
      )(payload);

      callback(rooms);
    } catch (error) {
      yield all([
        put(
          registerError([
            {
              system: error,
              user: "An error occurred fetching options for async dropdown"
            }
          ])
        )
      ]);
    }
  } else if (FIELD_IDS.VIRTUAL === fieldId) {
    try {
      const result = yield call(apiCall, {
        method: "get",
        url: "/virtual/locations/types"
      });

      const payload = R.prop("payload", result);

      const options = R.compose(
        R.map(el => ({
          value: R.prop("value", el),
          label: R.prop("text", el)
        }))
      )(payload);

      callback(options);
    } catch (error) {
      yield all([
        put(
          registerError([
            {
              system: error,
              user: "An error occurred fetching options for async dropdown"
            }
          ])
        )
      ]);
    }
  } else if (FIELD_IDS.SESSION_SUBMITTER === fieldId) {
    const eventId = yield select(getEventId);
    try {
      const {
        credentials: { userId }
      } = yield call(getParams);
      const filter = { userId };
      const { payload = [] } = yield call(apiCall, {
        method: "get",
        url: `/contacts/event/${eventId}/contacts/search`,
        qs: { ...filter, q: search }
      });

      const options = R.compose(
        R.map(el => ({
          value: R.prop("id", el) || "",
          label: R.prop("name", el) || ""
        })),
        R.filter(R.propEq("belongsToEvent", true))
      )(payload);

      callback(options || []);
    } catch (error) {
      yield all([
        put(
          registerError([
            {
              system: error,
              user: "An error occurred fetching options for async dropdown"
            }
          ])
        )
      ]);
    }
  }
};

const showContentModal = function*({ payload = "" }) {
  yield all([
    put(actions.setIsVideoContent(payload === CONTENT_VIDEO)),
    put(
      MediaContentActions.setShowModal(true, {
        meta: { instanceId: CONTENT_MODAL_ID }
      })
    )
  ]);
};

const unlinkSubsession = function*({ payload: { subsessionId } }) {
  if (!subsessionId) return true;
  const credentials = yield select(getCredentials);
  const parentSessionId = yield select(getters.sessionId);
  yield put(actions.setLoading(true));
  try {
    yield call(Api.unlinkSubsession, {
      credentials,
      subsessionId
    });
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: "An error occurred while unlinking subsession"
        }
      ])
    );
  } finally {
    yield call(init, {
      payload: {
        sessionId: parentSessionId,
        parentSessionId: null,
        returnToScene: TABS.SUBSESSIONS
      }
    });
  }

  return true;
};

const onMenuSelectSubsession = function*({
  payload: { subsessionId, method }
}) {
  if (!method || !subsessionId) return true;
  if (method === SUBSESSION_ACTIONS.unlink) {
    yield call(unlinkSubsession, {
      payload: {
        subsessionId
      }
    });
  } else if (method === SUBSESSION_ACTIONS.delete) {
    yield call(deleteSubsession, {
      payload: {
        subsessionId
      }
    });
  }
  yield all([put(actions.onSaveDone()), put(actions.setLoading(false))]);

  return true;
};

const deleteSubsession = function*({ payload: { subsessionId } }) {
  if (!subsessionId) return true;
  const credentials = yield select(getCredentials);
  const parentSessionId = yield select(getters.sessionId);
  yield put(actions.setLoading(true));
  try {
    yield call(Api.deleteSubsession, {
      credentials,
      subsessionId
    });
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: "An error occurred while deleting subsession"
        }
      ])
    );
  } finally {
    yield call(init, {
      payload: {
        sessionId: parentSessionId,
        parentSessionId: null,
        returnToScene: TABS.SUBSESSIONS
      }
    });
  }
  return true;
};

const watchShowContentModal = function*() {
  yield takeEvery(actions.showContentModal.type, showContentModal);
};

const watchHandleDraftCancel = function*() {
  yield takeEvery(actions.saveAsDraft.type, saveAsDraft);
};

const watchInit = function*() {
  yield takeEvery(actions.initSessionModal.type, init);
};

const watchSave = function*() {
  yield takeEvery(actions.save.type, save);
};

const watchNextPage = function*() {
  yield takeEvery(actions.nextPage.type, nextPage);
};

const watchPreviousPage = function*() {
  yield takeEvery(actions.previousPage.type, previousPage);
};

const watchUploadHeaderImg = function*() {
  yield takeEvery(actions.uploadHeaderImg.type, uploadHeaderImg);
};

const watchLoadAsyncStatusOptions = debounce(
  action =>
    action.type === FormActions.dataRequest.type &&
    R.path(["meta", "fieldId"], action) === FIELD_IDS.STATUS &&
    R.path(["meta", "instanceId"], action) === SESSION_FORM_ID,
  loadAsyncOptions,
  250
);

const watchLoadAsyncTagOptions = debounce(
  action =>
    action.type === FormActions.dataRequest.type &&
    R.path(["meta", "fieldId"], action) === FIELD_IDS.TAGS &&
    R.path(["meta", "instanceId"], action) === SESSION_FORM_ID,
  loadAsyncOptions,
  250
);

const watchLoadAsyncLevelOptions = debounce(
  action =>
    action.type === FormActions.dataRequest.type &&
    R.path(["meta", "fieldId"], action) === FIELD_IDS.LEVEL &&
    R.path(["meta", "instanceId"], action) === SESSION_FORM_ID,
  loadAsyncOptions,
  250
);

const watchLoadAsyncTrackOptions = debounce(
  action =>
    action.type === FormActions.dataRequest.type &&
    R.path(["meta", "fieldId"], action) === FIELD_IDS.TRACK &&
    R.path(["meta", "instanceId"], action) === SESSION_FORM_ID,
  loadAsyncOptions,
  250
);

const watchLoadAsyncLanguageOptions = debounce(
  action =>
    action.type === FormActions.dataRequest.type &&
    R.path(["meta", "fieldId"], action) === FIELD_IDS.LANGUAGE &&
    R.path(["meta", "instanceId"], action) === SESSION_FORM_ID,
  loadAsyncOptions,
  250
);

const watchLoadAsyncFormatOptions = debounce(
  action =>
    action.type === FormActions.dataRequest.type &&
    R.path(["meta", "fieldId"], action) === FIELD_IDS.FORMAT &&
    R.path(["meta", "instanceId"], action) === SESSION_FORM_ID,
  loadAsyncOptions,
  250
);

const watchLoadAsyncSpeakerOptions = debounce(
  action =>
    action.type === FormActions.dataRequest.type &&
    R.path(["meta", "fieldId"], action) === FIELD_IDS.SPEAKERS &&
    R.path(["meta", "instanceId"], action) === SESSION_FORM_ID,
  loadAsyncOptions,
  250
);

const watchLoadAsyncChairPersonsOptions = debounce(
  action =>
    action.type === FormActions.dataRequest.type &&
    R.path(["meta", "fieldId"], action) === FIELD_IDS.CHAIRPERSONS &&
    R.path(["meta", "instanceId"], action) === SESSION_FORM_ID,
  loadAsyncOptions,
  250
);

const watchLoadAsyncModeratorsOptions = debounce(
  action =>
    action.type === FormActions.dataRequest.type &&
    R.path(["meta", "fieldId"], action) === FIELD_IDS.MODERATORS &&
    R.path(["meta", "instanceId"], action) === SESSION_FORM_ID,
  loadAsyncOptions,
  250
);

const watchLoadAsyncSponsorOptions = debounce(
  action =>
    action.type === FormActions.dataRequest.type &&
    R.path(["meta", "fieldId"], action) === FIELD_IDS.SPONSORS &&
    R.path(["meta", "instanceId"], action) === SESSION_FORM_ID,
  loadAsyncOptions,
  250
);

const watchLoadAsyncExhibitorOptions = debounce(
  action =>
    action.type === FormActions.dataRequest.type &&
    R.path(["meta", "fieldId"], action) === FIELD_IDS.EXHIBITORS &&
    R.path(["meta", "instanceId"], action) === SESSION_FORM_ID,
  loadAsyncOptions,
  250
);

const watchLoadAsyncRoomOptions = debounce(
  action =>
    action.type === FormActions.dataRequest.type &&
    R.path(["meta", "fieldId"], action) === FIELD_IDS.LOCATION_ROOM &&
    R.path(["meta", "instanceId"], action) === SESSION_FORM_ID,
  loadAsyncOptions,
  250
);

const watchLoadAsyncVirtualOptions = debounce(
  action =>
    action.type === FormActions.dataRequest.type &&
    R.path(["meta", "fieldId"], action) === FIELD_IDS.VIRTUAL &&
    R.path(["meta", "instanceId"], action) === SESSION_FORM_ID,
  loadAsyncOptions,
  250
);
const watchLoadAsyncSessionSubmitterOptions = debounce(
  action =>
    action.type === FormActions.dataRequest.type &&
    R.path(["meta", "fieldId"], action) === FIELD_IDS.SESSION_SUBMITTER &&
    R.path(["meta", "instanceId"], action) === SESSION_FORM_ID,
  loadAsyncOptions,
  250
);

const watchSelectMedia = function*() {
  for (;;) {
    const {
      payload,
      meta: { instanceId }
    } = yield take(MediaContentActions.selectRecord.type);
    if (instanceId === CONTENT_MODAL_ID) {
      const isVideoContent = yield select(getters.isVideoContent);

      if (isVideoContent) {
        yield put(actions.addContentVideo(payload));
      } else {
        yield put(actions.addContent(payload));
      }
    }
  }
};

const searchSessions = function*({ payload: { filter } }) {
  const state = yield select(R.identity);
  const credentials = yield select(getCredentials);
  const sessionId = yield getters.sessionId(state);
  const pagination = yield getters.pagination(state);
  const sessionsToConvertIds = yield getters.sessionsToConvertIds(state);
  // const sessionsToConvert = yield getters.sessionsToConvert(state);

  yield put(actions.setLoading(true));
  const { page, pageSize } = pagination;
  try {
    const response = yield call(Api.getSessions, {
      sessionId,
      credentials,
      page,
      pageSize,
      search: filter
    });
    const formattedSessionsToConvert = R.compose(
      R.map(session => ({
        ...session,
        isSelected: !!sessionsToConvertIds.includes(session.id)
      })),
      R.pathOr([], ["payload", "rows"])
    )(response);
    yield put(actions.setSessionsToConvert(formattedSessionsToConvert));
    yield put(
      actions.setPagination(R.pathOr(0, ["payload", "pagination"], response))
    );
    yield put(
      actions.setSessionsToConvertCounter(
        R.path(["payload", "counters", "all"], response)
      )
    );
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: "An error occurred"
        }
      ])
    );
  } finally {
    yield put(actions.setLoading(false));
  }
  return true;
};

const selectItem = function*({ payload: { id, isSelected } }) {
  const state = yield select(R.identity);
  const records = yield getters.sessionsToConvert(state);
  const selectedsessionsToConvert = yield getters.selectedsessionsToConvert(
    state
  );
  const getRecordId = R.propEq("id", id);
  const changeSelectedValue = record => ({
    ...record,
    isSelected: !record.isSelected
  });
  const newRecords = R.map(R.when(getRecordId, changeSelectedValue), records);

  // const getIsSelectedRecord = R.propEq("isSelected", true);

  // const recordToChange = R.filter(getRecordId, newRecords);

  const filterFn = record => record.id !== id;
  const addFn = record => record.id === id;
  const getId = R.prop("id");
  const filteredSessionsToConvert = isSelected
    ? [...selectedsessionsToConvert, ...R.filter(addFn, newRecords)]
    : R.filter(filterFn, selectedsessionsToConvert);

  const remainingIds = R.map(getId, filteredSessionsToConvert);
  yield all([
    put(actions.setSessionsToConvert(newRecords)),
    put(actions.setSelectedsessionsToConvert(filteredSessionsToConvert)),
    put(actions.setSessionsToConvertIds(remainingIds))
  ]);

  return true;
};

const beforeOpenFullPage = function*() {
  const hasChanges = yield select(getters.hasChanges);
  if (!hasChanges) {
    yield call(openFullPage);
  } else {
    yield put(actions.setHasUnSavedChangesModal(true));
  }
};

const openFullPage = function*() {
  const eventId = yield select(getEventId);
  const history = "sessions/submissions";
  const state = yield select(R.identity);
  const sessionId = yield getters.sessionId(state);
  yield call(
    openInNewWindow,
    `/event-light/${eventId}/sessions/${sessionId}/details?history=${history}`
  );
};
const onCancelUnsavedChanges = function*() {
  yield put(actions.setHasUnSavedChangesModal(false));
  yield call(openFullPage);
};
const onConfirmUnsavedChanges = function*() {
  yield put(actions.setHasUnSavedChangesModal(false));
  yield put(actions.save());
  yield call(openFullPage);
};

const watchTabs = function*() {
  yield takeEvery(TabsActions.setSelectedTab.type, onTabChange);
};

const watchCreateSubsession = function*() {
  yield takeEvery(actions.createSubsession.type, createSubsession);
};

const watchGoToParentSession = function*() {
  yield takeEvery(actions.goToParentSession.type, goToParentSession);
};

const watchGoToSubsession = function*() {
  yield takeEvery(actions.goToSubsession.type, goToSubsession);
};

const watchUnlinkSubsession = function*() {
  yield takeEvery(actions.unlinkSubsession.type, unlinkSubsession);
};

const watchDeleteSubsession = function*() {
  yield takeEvery(actions.deleteSubsession.type, deleteSubsession);
};

const watchOnMenuSelectSubsession = function*() {
  yield takeEvery(actions.onMenuSelectSubsession.type, onMenuSelectSubsession);
};

const watchSearchSessions = function*() {
  yield takeEvery(actions.searchSessions.type, searchSessions);
};

const watchSelectedItem = function*() {
  yield takeEvery(actions.selectItem.type, selectItem);
};

const watchHandleChangePages = function*() {
  yield takeEvery(actions.handleChangePages.type, handleChangePages);
};

const watchHandleChangeResultPerPage = function*() {
  yield takeEvery(
    actions.handleChangeResultPerPage.type,
    handleChangeResultPerPage
  );
};

const watchLinkSessionAsSubsession = function*() {
  yield takeEvery(
    actions.linkSessionAsSubsession.type,
    linkSessionAsSubsession
  );
};
const watchOpenFullPage = function*() {
  yield takeEvery(actions.openFullPage.type, beforeOpenFullPage);
};
const watchOnCancelUnsavedChanges = function*() {
  yield takeEvery(actions.onCancelUnsavedChanges.type, onCancelUnsavedChanges);
};
const WatchOnConfirmUnsavedChanges = function*() {
  yield takeEvery(
    actions.onConfirmUnsavedChanges.type,
    onConfirmUnsavedChanges
  );
};

const watchShowBulkEditSpeakersModal = function*() {
  yield takeEvery(
    actions.showBulkEditSpeakersModal.type,
    onShowBulkEditSpeakersModal
  );
};

const rootSaga = function*() {
  yield all([
    fork(watchShowBulkEditSpeakersModal),
    fork(watchHandleDraftCancel),
    fork(watchInit),
    fork(watchSave),
    fork(watchTabs),
    fork(watchNextPage),
    fork(watchPreviousPage),
    fork(watchUpdateFields),
    fork(watchUploadHeaderImg),
    fork(watchLoadAsyncTagOptions),
    fork(watchLoadAsyncStatusOptions),
    fork(watchLoadAsyncFormatOptions),
    fork(watchLoadAsyncLevelOptions),
    fork(watchLoadAsyncLanguageOptions),
    fork(watchLoadAsyncSpeakerOptions),
    fork(watchLoadAsyncSponsorOptions),
    fork(watchLoadAsyncExhibitorOptions),
    fork(watchLoadAsyncVirtualOptions),
    fork(watchLoadAsyncRoomOptions),
    fork(watchLoadAsyncTrackOptions),
    fork(watchLoadAsyncSessionSubmitterOptions),
    fork(watchSelectMedia),
    fork(watchShowContentModal),
    fork(watchLoadAsyncChairPersonsOptions),
    fork(watchLoadAsyncModeratorsOptions),
    fork(watchCreateSubsession),
    fork(watchGoToParentSession),
    fork(watchGoToSubsession),
    fork(watchUnlinkSubsession),
    fork(watchDeleteSubsession),
    fork(watchOnMenuSelectSubsession),
    fork(watchSearchSessions),
    fork(watchSelectedItem),
    fork(watchLinkSessionAsSubsession),
    fork(watchHandleChangePages),
    fork(watchHandleChangeResultPerPage),
    fork(watchOpenFullPage),
    fork(watchOnCancelUnsavedChanges),
    fork(WatchOnConfirmUnsavedChanges)
  ]);
};

export default rootSaga;
